module.exports = __webpack_public_path__ + "img/1395.7fbc3cca.gif";